import Api from "./Api.js";

const resource = "/shipping-methods";

export default {
  get(filters) {
    return Api.get(`${resource}`, {
      params: filters
    });
  }
};
